import React from 'react';

const tempColor = (v) => {
    if (v >= 67) return { stroke: '#a3e635', glow: 'rgba(163, 230, 53, 0.7)', label: 'HOT' };
    if (v >= 34) return { stroke: '#22d3ee', glow: 'rgba(34, 211, 238, 0.7)', label: 'WARM' };
    return { stroke: '#e879f9', glow: 'rgba(232, 121, 249, 0.6)', label: 'COLD' };
};

const Thermometer = ({ value = 50, size = 'md', showLabel = true }) => {
    const v = Math.max(0, Math.min(100, Math.round(value)));
    const { stroke, glow, label } = tempColor(v);

    const dims = size === 'sm'
        ? { w: 44, h: 140, tube: 14, bulb: 22 }
        : { w: 56, h: 180, tube: 18, bulb: 28 };

    const tubeTop = 18;
    const tubeBottom = dims.h - dims.bulb - 8;
    const fillHeight = ((tubeBottom - tubeTop) * v) / 100;
    const fillY = tubeBottom - fillHeight;

    return (
        <div className="flex flex-col items-center gap-2 select-none">
            {showLabel && (
                <div className="flex flex-col items-center">
                    <span className="text-[10px] font-mono tracking-[0.2em] text-neon-cyan/70 uppercase">TEMP</span>
                    <span
                        className="text-2xl font-mono font-bold tabular-nums"
                        style={{ color: stroke, textShadow: `0 0 8px ${glow}` }}
                    >
                        {v}
                    </span>
                </div>
            )}
            <svg
                width={dims.w}
                height={dims.h}
                viewBox={`0 0 ${dims.w} ${dims.h}`}
                className="overflow-visible"
                aria-label={`Termómetro ${v}/100`}
            >
                <defs>
                    <linearGradient id="thermoFill" x1="0" x2="0" y1="0" y2="1">
                        <stop offset="0%" stopColor={stroke} stopOpacity="0.95" />
                        <stop offset="100%" stopColor={stroke} stopOpacity="0.65" />
                    </linearGradient>
                </defs>

                {/* Marcas laterales */}
                {[0, 25, 50, 75, 100].map((m) => {
                    const y = tubeBottom - ((tubeBottom - tubeTop) * m) / 100;
                    return (
                        <line
                            key={m}
                            x1={dims.w / 2 + dims.tube / 2 + 3}
                            x2={dims.w / 2 + dims.tube / 2 + 9}
                            y1={y}
                            y2={y}
                            stroke="rgba(34, 211, 238, 0.35)"
                            strokeWidth="1"
                        />
                    );
                })}

                {/* Tubo (contenedor) */}
                <rect
                    x={(dims.w - dims.tube) / 2}
                    y={tubeTop}
                    width={dims.tube}
                    height={tubeBottom - tubeTop}
                    rx={dims.tube / 2}
                    fill="rgba(10, 10, 20, 0.7)"
                    stroke="rgba(34, 211, 238, 0.4)"
                    strokeWidth="1.5"
                />

                {/* Líquido */}
                <rect
                    x={(dims.w - dims.tube) / 2 + 2}
                    y={fillY}
                    width={dims.tube - 4}
                    height={fillHeight}
                    rx={(dims.tube - 4) / 2}
                    fill="url(#thermoFill)"
                    style={{
                        filter: `drop-shadow(0 0 6px ${glow})`,
                        transition: 'y 0.5s cubic-bezier(0.4, 0, 0.2, 1), height 0.5s cubic-bezier(0.4, 0, 0.2, 1), fill 0.4s',
                    }}
                />

                {/* Bulbo */}
                <circle
                    cx={dims.w / 2}
                    cy={dims.h - dims.bulb / 2 - 4}
                    r={dims.bulb / 2}
                    fill={stroke}
                    stroke="rgba(255, 255, 255, 0.15)"
                    strokeWidth="1"
                    style={{ filter: `drop-shadow(0 0 10px ${glow})` }}
                    className="thermo-active"
                />
                <circle
                    cx={dims.w / 2 - 3}
                    cy={dims.h - dims.bulb / 2 - 6}
                    r={dims.bulb / 6}
                    fill="rgba(255, 255, 255, 0.4)"
                />

                {/* Conexión bulbo-tubo */}
                <rect
                    x={(dims.w - dims.tube) / 2}
                    y={tubeBottom}
                    width={dims.tube}
                    height={8}
                    fill="rgba(10, 10, 20, 0.7)"
                    stroke="rgba(34, 211, 238, 0.4)"
                    strokeWidth="1.5"
                />
            </svg>
            {showLabel && (
                <span
                    className="text-[9px] font-mono tracking-[0.25em] uppercase"
                    style={{ color: stroke, opacity: 0.7 }}
                >
                    {label}
                </span>
            )}
        </div>
    );
};

export default Thermometer;
